import { render } from "./errorPage.vue?vue&type=template&id=6108c3ef&lang=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"

import "./errorPage.vue?vue&type=style&index=0&id=6108c3ef&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__